import { useMemo } from 'react'
import { GitBranch } from 'react-feather'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Card, CardBody } from 'reactstrap'
import { URL_MUTATION_REPORT } from 'utils/pathUrl'
import { useFetchMutationReportQuery } from 'features/private-views/mutation-report/mutationReportSlice'
import '../styles.css'

const LaporanKetelusuranSection = ({ transaction, isBuyer }) => {
  const navigate = useNavigate()
  const { ownerData } = useSelector((s) => s.dashboard || {})

  const isBuyTransaction = useMemo(() => {
    if (typeof isBuyer === 'boolean') {
      return isBuyer
    }
    if (transaction?.buyerDetail?.userId && ownerData?.userId) {
      return Number(transaction.buyerDetail.userId) === Number(ownerData.userId)
    }
    return transaction?.orderDetail?.type === 'BUY'
  }, [isBuyer, transaction, ownerData])

  const transactionNumber =
    transaction?.orderDetail?.transaction_number?.trim() ||
    transaction?.orderDetail?.poNumber?.trim()

  const isCompleted = transaction?.status?.toLowerCase() === 'selesai'

  const { data, isLoading } = useFetchMutationReportQuery(
    { search: transactionNumber },
    { skip: !isCompleted || !transactionNumber },
  )

  const mutationItem = data?.items?.[0]
  const mutationId = mutationItem?.id

  if (!isCompleted || isLoading || !mutationId) {
    return null
  }

  const handleClick = () => {
    if (isBuyTransaction) {
      navigate(`${URL_MUTATION_REPORT}/${mutationId}`, {
        state: { rowData: mutationItem, direction: 'FORWARD' },
      })
    } else {
      navigate(
        `${URL_MUTATION_REPORT}/${mutationId}?direction=BACKWARD`,
        {
          state: { rowData: mutationItem, direction: 'BACKWARD' },
        },
      )
    }
  }

  return (
    <Card
      className="shadow-sm text-center mb-3"
      style={{
        backgroundColor: '#ECFAFF',
        border: '1px solid #8ABBCC !important',
      }}
      data-testid="laporan-ketelusuran-island"
    >
      <CardBody>
        <Button
          outline
          color="primary"
          className="w-100 btn-ketelusuran d-flex align-items-center justify-content-center gap-1"
          data-testid="laporan-ketelusuran-btn"
          onClick={handleClick}
          style={{
            backgroundColor: '#FFFFFF',
          }}
        >
          <GitBranch size={16} />
          <span style={{ marginLeft: '4px' }}>Laporan Ketelusuran</span>
        </Button>
      </CardBody>
    </Card>
  )
}

export default LaporanKetelusuranSection
